import { observeElement, getWidget } from '@uvocore-front/utils';
import { tns } from 'tiny-slider/src/tiny-slider';
import 'tiny-slider/src/tiny-slider.scss';
import Loader from '../UI/loader';
import './styles.scss';
import config from './config';

const TestimonialsInit = () => {
  const testimonials = document.querySelector('[data-testimonials]');
  const sliderContainer = testimonials.querySelector('[data-testimonials-container]');
  const slidesCount = testimonials.getAttribute('data-slides-count')
    ? testimonials.getAttribute('data-slides-count')
    : 2;
  const nextButton = testimonials.querySelector('.testimonials__btn-next');

  const initSlider = () => {
    if (sliderContainer) {
      const slider = tns({
        container: sliderContainer,
        items: slidesCount,
        loop: false,
        nav: false,
        controls: false,
        autoWidth: true,
        mouseDrag: true,
        useLocalStorage: false,
        responsive: {
          1024: {
            autoWidth: true,
            edgePadding: 2,
          },
        },
        onInit: () => {
          if (!nextButton) return;

          nextButton.classList.add('testimonials__btn-next--visible');
          nextButton.addEventListener('click', () => {
            const state = slider.getInfo();

            if (state.displayIndex + 1 >= state.slideCount) {
              slider.goTo('first');
            } else {
              slider.goTo('next');
            }
          });
        },
      });

      window.addEventListener('resize', () => {
        slider.rebuild();
      });
    }
  };

  observeElement({
    element: '[data-testimonials]',
    marginValue: 300,
    callback: () => {
      if (!sliderContainer.children.length) {
        getWidget({
          widgetLink: '/assets/js/testimonialsWidget.min.js',
          customLoader: Loader,
          insertLoaderTo: '[data-testimonials-container]',
          fn: () => {
            window.tmWidget({ ...config, callbackLoaded: initSlider });
          },
        });
      } else {
        initSlider();
      }
    },
  });
};

// if (document.querySelector('[data-testimonials]')) {
//   TestimonialsInit();
// }

export default TestimonialsInit;
